module.exports = __webpack_public_path__ + "img/fulham-logo-icon.cbf97695.png";